import { msg } from "@lit/localize";
import { createAsyncAction } from "@progressive-development/pd-spa-helper";

import type { SitzungenListe } from "../service/sitzungen-service.js";

/** Das Listen-Artefakt — einmal je Besuch (`fireOnce`); Sicht und Filter leben im URL. */
export const loadSitzungenListe = createAsyncAction<SitzungenListe>("LOAD_SITZUNGEN_LISTE", {
  loadingTxt: msg("Sitzungen werden geladen…", { id: "app.bv.sitzungen.loading.toast" }),
  smallBackground: true,
});
